"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Gets the JSON object from the server. Returns deserialized JSON response.
 * @param url The path to the resource.
 */
function getJson(url) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = toJson;
                    return [4 /*yield*/, fetch(url, getFetchArgs())];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
exports.getJson = getJson;
/**
 * Issues HTTP GET to the server. HTTP OK determines boolean result.
 * @param url The path to the resource.
 */
function getJsonOk(url) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = checkOk;
                    return [4 /*yield*/, fetch(url, getFetchArgs())];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
exports.getJsonOk = getJsonOk;
/**
 * Deletes the resource on server. Returns deserialized JSON response.
 * @param url The path to the resource.
 */
function deleteJson(url) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = toJson;
                    return [4 /*yield*/, fetch(url, __assign({}, getFetchArgs(), { method: 'delete' }))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
exports.deleteJson = deleteJson;
/**
 * Issues HTTP DELETE to the server. HTTP OK determines boolean result.
 * @param url The path to the resource.
 */
function deleteJsonOk(url) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = checkOk;
                    return [4 /*yield*/, fetch(url, __assign({}, getFetchArgs(), { method: 'delete' }))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
exports.deleteJsonOk = deleteJsonOk;
/**
 * Posts the JavaScript object to the server. Returns deserialized JSON response.
 * @param url The path to the resource.
 * @param data A JavaScript value to be serialized.
 */
function postJson(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = toJson;
                    return [4 /*yield*/, fetch(url, __assign({}, getFetchArgs(), { method: 'post', body: JSON.stringify(data) }))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
exports.postJson = postJson;
/**
 * Posts the JavaScript object. HTTP OK determines boolean result.
 * @param url The path to the resource.
 * @param data A JavaScript value to be serialized.
 */
function postJsonOk(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = checkOk;
                    return [4 /*yield*/, fetch(url, __assign({}, getFetchArgs(), { method: 'post', body: JSON.stringify(data) }))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
exports.postJsonOk = postJsonOk;
/**
 * Puts the JavaScript object. Returns deserialized JSON response.
 * @param url The path to the resource.
 * @param data A JavaScript value to be serialized.
 */
function putJson(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = toJson;
                    return [4 /*yield*/, fetch(url, __assign({}, getFetchArgs(), { method: 'put', body: JSON.stringify(data) }))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
exports.putJson = putJson;
/**
 * Puts the JavaScript object. HTTP OK determines boolean result.
 * @param url The path to the resource.
 * @param data A JavaScript value to be serialized.
 */
function putJsonOk(url, data) {
    return __awaiter(this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = checkOk;
                    return [4 /*yield*/, fetch(url, __assign({}, getFetchArgs(), { method: 'put', body: JSON.stringify(data) }))];
                case 1: return [2 /*return*/, _a.apply(void 0, [_b.sent()])];
            }
        });
    });
}
exports.putJsonOk = putJsonOk;
function checkOk(resp) {
    return resp.ok;
}
function toJson(resp) {
    if (resp.status >= 200 && resp.status < 300) {
        return resp.json();
    }
    else {
        throw new Error(resp.statusText);
    }
}
function getFetchArgs() {
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include'
    };
}
